<template lang="pug">
label.v-field-tumbler.field-tumbler
	input.field-tumbler__input(
			type="checkbox"
			:value="trueValue"
			v-model="localValue"
			@change="handleInput"
			:disabled="disabled"
			:aria-labelledby="(labelId ? labelId + ' ' + uniqueId : null)"
			:id="uniqueId")
	.field-tumbler__visual
	span.field-tumbler__text(v-if="text" v-html="text")
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId';

export default {
	props: {
		text: {
			type: [String, Number],
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean],
			default: null
		},

		trueValue: {
			type: [Object, String, Number],
			default: null
		},

		disabled: {
			type: Boolean,
			default: false
		},

		labelId: {
			type: String,
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			open: false,
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		}
	}
};
</script>
